import { CATEGORY } from '../components/ui/categoryColors';
import { EventColorEntry, ScheduleEvent } from './types';

/**
 * 16 event chip colours from the category family (components/ui/categoryColors.ts): a mark fill at
 * 20% and a mark rule at 50% under ink text. 20% is the most fill that keeps the ink at Lc 60.
 * Each entry's bg/text/border strings also carry a `day:` sibling for the light theme. Tailwind's
 * JIT builds only classes it can read literally, so the oklch() values are written out here and
 * schedule-colors.test.ts holds them to the family.
 */
const PALETTE: EventColorEntry[] = [
  { bg: 'bg-[color:oklch(0.7_0.16_50_/_0.2)] day:bg-orange-100', text: 'text-[color:oklch(0.83_0.104_50)] day:text-orange-700', border: 'border-[color:oklch(0.7_0.16_50_/_0.5)] day:border-orange-300', hex: CATEGORY.orange.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_254_/_0.2)] day:bg-blue-100', text: 'text-[color:oklch(0.83_0.086_254)] day:text-blue-700', border: 'border-[color:oklch(0.7_0.16_254_/_0.5)] day:border-blue-300', hex: CATEGORY.blue.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.121_188_/_0.2)] day:bg-teal-100', text: 'text-[color:oklch(0.83_0.13_188)] day:text-teal-700', border: 'border-[color:oklch(0.7_0.121_188_/_0.5)] day:border-teal-300', hex: CATEGORY.teal.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_300_/_0.2)] day:bg-purple-100', text: 'text-[color:oklch(0.83_0.099_300)] day:text-purple-700', border: 'border-[color:oklch(0.7_0.16_300_/_0.5)] day:border-purple-300', hex: CATEGORY.purple.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_344_/_0.2)] day:bg-pink-100', text: 'text-[color:oklch(0.83_0.121_344)] day:text-pink-700', border: 'border-[color:oklch(0.7_0.16_344_/_0.5)] day:border-pink-300', hex: CATEGORY.pink.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_148_/_0.2)] day:bg-green-100', text: 'text-[color:oklch(0.83_0.13_148)] day:text-green-700', border: 'border-[color:oklch(0.7_0.16_148_/_0.5)] day:border-green-300', hex: CATEGORY.green.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.143_94_/_0.2)] day:bg-yellow-100', text: 'text-[color:oklch(0.83_0.13_94)] day:text-yellow-700', border: 'border-[color:oklch(0.7_0.143_94_/_0.5)] day:border-yellow-300', hex: CATEGORY.yellow.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_25_/_0.2)] day:bg-red-100', text: 'text-[color:oklch(0.83_0.094_25)] day:text-red-700', border: 'border-[color:oklch(0.7_0.16_25_/_0.5)] day:border-red-300', hex: CATEGORY.red.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.121_210_/_0.2)] day:bg-cyan-100', text: 'text-[color:oklch(0.83_0.13_210)] day:text-cyan-700', border: 'border-[color:oklch(0.7_0.121_210_/_0.5)] day:border-cyan-300', hex: CATEGORY.cyan.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.149_72_/_0.2)] day:bg-amber-100', text: 'text-[color:oklch(0.83_0.13_72)] day:text-amber-700', border: 'border-[color:oklch(0.7_0.149_72_/_0.5)] day:border-amber-300', hex: CATEGORY.amber.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_122_/_0.2)] day:bg-lime-100', text: 'text-[color:oklch(0.83_0.13_122)] day:text-lime-700', border: 'border-[color:oklch(0.7_0.16_122_/_0.5)] day:border-lime-300', hex: CATEGORY.lime.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.158_276_/_0.2)] day:bg-indigo-100', text: 'text-[color:oklch(0.83_0.085_276)] day:text-indigo-700', border: 'border-[color:oklch(0.7_0.158_276_/_0.5)] day:border-indigo-300', hex: CATEGORY.indigo.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_4_/_0.2)] day:bg-rose-100', text: 'text-[color:oklch(0.83_0.099_4)] day:text-rose-700', border: 'border-[color:oklch(0.7_0.16_4_/_0.5)] day:border-rose-300', hex: CATEGORY.rose.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.142_232_/_0.2)] day:bg-sky-100', text: 'text-[color:oklch(0.83_0.103_232)] day:text-sky-700', border: 'border-[color:oklch(0.7_0.142_232_/_0.5)] day:border-sky-300', hex: CATEGORY.sky.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.141_168_/_0.2)] day:bg-emerald-100', text: 'text-[color:oklch(0.83_0.13_168)] day:text-emerald-700', border: 'border-[color:oklch(0.7_0.141_168_/_0.5)] day:border-emerald-300', hex: CATEGORY.emerald.mark.hex },
  { bg: 'bg-[color:oklch(0.7_0.16_322_/_0.2)] day:bg-fuchsia-100', text: 'text-[color:oklch(0.83_0.13_322)] day:text-fuchsia-700', border: 'border-[color:oklch(0.7_0.16_322_/_0.5)] day:border-fuchsia-300', hex: CATEGORY.fuchsia.mark.hex },
];

/**
 * Build a deterministic event→color map.
 * Events sorted by date get sequential palette slots, ensuring
 * adjacent events in the calendar look visually distinct.
 */
export function buildEventColorMap(events: ScheduleEvent[]): Map<string, EventColorEntry> {
  const sorted = [...events].sort((a, b) => a.event_date.localeCompare(b.event_date));
  const map = new Map<string, EventColorEntry>();

  sorted.forEach((event, i) => {
    map.set(event.id, PALETTE[i % PALETTE.length]);
  });

  return map;
}

/** Row-glow: bg tint + inset top/bottom 1px yellow rails. Aligns across cell borders so
 *  the row reads as one continuous horizontal strip — name cell to count cell, blanks included. */
export const ROW_GLOW_CLASSES =
  'bg-primary/[0.08] day:bg-amber-100/70 ' +
  'shadow-[inset_0_1px_0_rgba(255,204,51,0.35),inset_0_-1px_0_rgba(255,204,51,0.35)] ' +
  'day:shadow-[inset_0_1px_0_rgba(217,119,6,0.4),inset_0_-1px_0_rgba(217,119,6,0.4)]';

/** Column-glow: bg tint + inset left/right 1px yellow rails. Forms a vertical strip from the
 *  day-of-week header through the staff rows down to the bottom of the grid. */
export const COL_GLOW_CLASSES =
  'bg-primary/[0.08] day:bg-amber-100/70 ' +
  'shadow-[inset_1px_0_0_rgba(255,204,51,0.35),inset_-1px_0_0_rgba(255,204,51,0.35)] ' +
  'day:shadow-[inset_1px_0_0_rgba(217,119,6,0.4),inset_-1px_0_0_rgba(217,119,6,0.4)]';

/** Intersection where row + col both glow — combine all four rails + a brighter tint. */
export const ROW_COL_INTERSECT_CLASSES =
  'bg-primary/[0.16] day:bg-amber-200 ' +
  'shadow-[inset_0_1px_0_rgba(255,204,51,0.5),inset_0_-1px_0_rgba(255,204,51,0.5),inset_1px_0_0_rgba(255,204,51,0.5),inset_-1px_0_0_rgba(255,204,51,0.5)] ' +
  'day:shadow-[inset_0_1px_0_rgba(217,119,6,0.55),inset_0_-1px_0_rgba(217,119,6,0.55),inset_1px_0_0_rgba(217,119,6,0.55),inset_-1px_0_0_rgba(217,119,6,0.55)]';

/** Pending-event styling — neutral gray so an unconfirmed show reads as
 *  "still on the board for planning" without competing visually with confirmed
 *  events. Applied to both day-header chips and assignment bars when
 *  `event.status === 'pending'`. Allowlist-of-one: if you add other
 *  non-confirmed statuses (e.g. 'tentative'), broaden the predicate at the
 *  call sites in ScheduleGrid.tsx and ScheduleCell.tsx. */
export const PENDING_EVENT_COLOR: EventColorEntry = {
  bg: 'bg-gray-700/20 day:bg-gray-200/60',
  text: 'text-on-surface-variant day:text-gray-500',
  border: 'border-gray-700/40 day:border-gray-300',
  hex: '#6b7280',
};

/** OOO cell styling — high-contrast in both modes (matches the spreadsheet feel).
 *  `text: 'text-white day:text-white'` is intentional: the day-mode override prevents
 *  ambient `day:text-gray-700` from cell ancestors cascading onto the OOO chip's white text. */
export const OOO_STYLE = {
  bg: 'bg-surface day:bg-gray-900',
  text: 'text-white day:text-white',
  border: 'border-gray-700 day:border-gray-800',
  tentativeBg: 'bg-gray-900 day:bg-gray-200',
  tentativeText: 'text-on-surface-variant day:text-gray-700',
};

/** Scheduler-authored unavailability block styling — diagonal hatch over muted
 *  slate. The hatch reads as "intentional do-not-book" and stays distinct from
 *  OOO solid black, the 16-color event palette, and pending-event gray. */
export const UNAVAILABLE_STYLE = {
  bg: 'bg-slate-700/40 day:bg-slate-200',
  text: 'text-slate-100 day:text-slate-700',
  border: 'border-slate-500/70 day:border-slate-400',
  // Diagonal stripes at low opacity. Applied as a className alongside `bg`
  // — the base color shows through between stripes for a layered effect.
  hatch:
    'bg-[repeating-linear-gradient(45deg,transparent_0,transparent_4px,rgba(100,116,139,0.35)_4px,rgba(100,116,139,0.35)_8px)] ' +
    'day:bg-[repeating-linear-gradient(45deg,transparent_0,transparent_4px,rgba(100,116,139,0.30)_4px,rgba(100,116,139,0.30)_8px)]',
};

export { PALETTE };
